import { Link } from "react-router-dom";
import { propsSubcoleccion } from "../../../models/Colecciones.model";

export default function Subcoleccion(props: propsSubcoleccion){

    return(
        <>
            <Link to={`colecciones/${props.id}`}><div className="square_collection_sub text_white justify-content-center"><div dangerouslySetInnerHTML={{__html: `${props.titulo}` }}></div> </div></Link>
        </>
    )
} 